import { siteBrand } from "@/mocks/news";

const footerColumns = [
  {
    title: "浏览",
    links: [
      { label: "实时滚动", href: "#live" },
      { label: "热门榜单", href: "#hot" },
      { label: "主题分类", href: "#topics" },
    ],
  },
  {
    title: "了解",
    links: [
      { label: "内容原则", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "订阅热点", href: "#subscribe" },
    ],
  },
  {
    title: "热门分类",
    links: [
      { label: "剧集动态", href: "#topics" },
      { label: "综艺录制", href: "#topics" },
      { label: "音乐现场", href: "#topics" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-primary-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-primary-50">
                黑
              </span>
              <span className="font-heading text-lg font-bold tracking-tight">{siteBrand.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/80">
              {siteBrand.slogan}。以时间线的方式整理正在发生的娱乐热点，标注每一条信息的真实状态。
            </p>
            <p className="mt-4 text-sm text-primary-100/70">
              联系邮箱：
              <a href={`mailto:${siteBrand.email}`} className="cursor-pointer text-accent-300 underline-offset-4 hover:underline">
                {siteBrand.email}
              </a>
            </p>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-heading text-sm font-semibold tracking-wider text-accent-300">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-primary-100/80 transition-colors hover:text-primary-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-100/60">
            © {new Date().getFullYear()} {siteBrand.name} · 站内内容均为公开讨论的整理与示例选题
          </p>
          <p className="text-xs text-primary-100/60">
            理性吃瓜 · 尊重当事人 · 不传播未经核实的信息
          </p>
        </div>
      </div>
    </footer>
  );
}